<template>
  <footer class="footer">
    <div class="footer__content">
      <b-container>
        <b-row>
          <b-col sm="12" md="6" class="footer__logo">
            <router-link to="/">
              <img
                alt="AnywhereInside Mobile UG (haftungsbeschraenkt)"
                src="../assets/img/brand-logo.svg"
                width="217px"
              />
            </router-link>
          </b-col>
          <b-col sm="12" md="6" class="footer__social">
            <a
              href="https://www.linkedin.com/company/anywhereinside"
              target="_blank"
            >
              <img
                alt="LinkedIn"
                class="social-icon"
                src="../assets/img/social-linkedin-black.svg"
              />
            </a>

            <a href="https://www.facebook.com/anywhereinside" target="_blank">
              <img
                alt="Facebook"
                class="social-icon"
                src="../assets/img/social-facebook-black.svg"
              />
            </a>

            <a href="https://twitter.com/anywhereinside" target="_blank">
              <img
                alt="Twitter"
                class="social-icon"
                src="../assets/img/social-twitter-black.svg"
              />
            </a>
          </b-col>
        </b-row>

        <b-row class="footer__links">
          <b-col>
            <h3 class="footer__title">Legal</h3>
            <ul>
              <li><router-link to="/privacy">Privacy Policy</router-link></li>
              <li><router-link to="/imprint">Imprint</router-link></li>
            </ul>
          </b-col>
          <b-col>
            <h3 class="footer__title">Resources</h3>

            <ul>
              <li>
                <a href="https://github.com/anywhereinside" target="_blank"
                  >Github</a
                >
              </li>
              <li>
                <a href="https://www.scrum.org/user/341048" target="_blank"
                  >SCRUM</a
                >
              </li>
            </ul>
          </b-col>

          <div class="w-100" />

          <b-col>
            <h3 class="footer__title">Support</h3>

            <ul>
              <li>
                <a
                  href="https://www.linkedin.com/in/jensdressler/"
                  target="_blank"
                  >Business Inquiry</a
                >
              </li>
              <li>
                <a href="mailto:info@anywhereinside.com" target="_blank"
                  >Contact us</a
                >
              </li>
            </ul>
          </b-col>
          <b-col>
            <h3 class="footer__title">graphapi®</h3>

            <ul>
              <li>
                <a href="https://graphapi.com/docs/" target="_blank"
                  >Documentation</a
                >
              </li>
              <li>
                <a href="https://my.graphapi.com" target="_blank"
                  >Try for free</a
                >
              </li>
            </ul>
          </b-col>
        </b-row>

        <div class="footer__copyright">
          &copy; {{ year }} AnywhereInside Mobile UG (haftungsbeschraenkt)
        </div>
      </b-container>
    </div>
  </footer>
</template>

<script>
export default {
  name: "DefaultFooter",
  computed: {
    year() {
      const date = new Date();
      return date.getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped="true">
@import "../assets/scss/variables";
@import "../assets/scss/mixins";
@import "../../node_modules/bootstrap/scss/functions";
@import "../../node_modules/bootstrap/scss/variables";
@import "../../node_modules/bootstrap/scss/mixins/breakpoints";

.footer {
  width: 100%;
  height: $footer-height;
  margin-bottom: 0;
  flex-shrink: 0;

  @include media-breakpoint-up(md) {
    height: $footer-height-md;
  }
}

.footer__logo {
  text-align: center;
  opacity: 0.7;

  @include media-breakpoint-up(md) {
    text-align: left;
  }
}

.footer__social {
  opacity: 0.7;
  text-align: center;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;

  @include media-breakpoint-up(md) {
    margin-top: 0;
    justify-content: flex-end;
  }
}

.social-icon {
  width: 34px;
  height: 34px;
  margin: 0 3px;
  display: block;
}

.footer__content {
  background-color: $footer-background-color;
  height: $footer-height;
  padding-top: 40px;

  @include media-breakpoint-up(md) {
    height: $footer-height-md;
  }
}

.footer__title {
  font-size: em(20);
  font-weight: bold;
  color: rgba(#000000, 0.15);
  margin-top: 20px;
}

.footer__links {
  text-align: center;
  margin-top: 20px;

  @include media-breakpoint-up(md) {
    text-align: left;
    margin-top: 40px;
  }

  ul {
    padding: 0;

    @include media-breakpoint-up(md) {
      margin-top: 20px;
    }
  }

  li {
    list-style-type: none;
  }

  a {
    font-size: em(16);
    line-height: 2.4;
    letter-spacing: normal;
    text-align: center;
    color: rgba(#000000, 0.5);
  }

  a:hover {
    color: $anchor-color;
    text-decoration: none;
  }

  .w-100 {
    @include media-breakpoint-up(md) {
      display: none;
    }
  }
}

.footer__copyright {
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: em(14);
  text-align: center;
  color: rgba(#000000, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/DefaultFooter.vue